import { Action } from '../actions/action'
import { surveyClosedState } from './closed'
import { permanentError } from './error'
import { InProgressStateImpl } from './inProgress'
import { surveyNotFoundState } from './notFound'
import type { BaseState, State } from './state'

export interface LoadingState extends BaseState {
  type: 'loading get'
  surveyId: string
  invitationId?: string
  answerId?: string
  overrideLang?: string
  customParams?: Record<string, string>
}

export class LoadingStateImpl implements LoadingState {
  type: 'loading get' = 'loading get'
  surveyId: string
  invitationId?: string
  answerId?: string
  overrideLang?: string
  customParams?: Record<string, string>
  constructor(args: {
    surveyId: string
    invitationId?: string
    answerId?: string
    overrideLang?: string
    customParams?: Record<string, string>
  }) {
    this.surveyId = args.surveyId
    this.invitationId = args.invitationId
    this.answerId = args.answerId
    this.overrideLang = args.overrideLang
    this.customParams = args.customParams
  }

  processAction(action: Action): State {
    if (action.type === 'get response') {
      switch (action.data.type) {
        case 'step':
          return new InProgressStateImpl({
            values: action.data.surveyValues || {},
            surveyId: this.surveyId,
            eventId: action.data.eventId,
            step: action.data.step,
            meta: action.data.meta,
            features: action.data.features,
            answerId: action.data.answerId,
            invitationId: this.invitationId,
            overrideLang: this.overrideLang,
            customParams: this.customParams,
          }).processDefaultvalues()
        case 'error': {
          switch (action.data.errorCode) {
            case 'surveyNotFound':
              return surveyNotFoundState
            case 'surveyClosed':
              return surveyClosedState
          }
          return this
        }
      }
    } else if (action.type === 'loading error') {
      return permanentError
    }
    return this
  }
}
